import { Box, Chip, Collapse, FormHelperText, Stack } from "@mui/material";
import { isEmpty } from "lodash";
import { useContext } from "react";
import { FilterContext } from "../../components/Filter";
import { estimateStates } from "./mock";

export const EstimatesAdvancedFilter = () => {
    const { compact, filterVisible, setFilter, filter } = useContext(FilterContext);

    return (
        <Collapse in={filterVisible}>
            <Box sx={{ my: 2, px: compact ? 2 : 0 }}>
                <Box>
                    <FormHelperText component="div" sx={{ mb: 1 }}>
                        Stav kalkulace
                    </FormHelperText>
                    <Stack direction="row" gap={1} flexWrap="wrap">
                        <Chip
                            label="Vše"
                            color={isEmpty(filter.states) ? "primary" : "default"}
                            onClick={() => setFilter({ ...filter, states: undefined })}
                        />
                        {Object.keys(estimateStates).map((estimateState) => {
                            const selected = filter.states?.includes(estimateState);
                            return (
                                <Chip
                                    key={estimateState}
                                    label={estimateState}
                                    color={selected ? "primary" : "default"}
                                    onClick={() =>
                                        setFilter({
                                            ...filter,
                                            states: selected
                                                ? filter.states?.filter(
                                                      (id) => id !== estimateState
                                                  )
                                                : [...(filter.states || []), estimateState],
                                        })
                                    }
                                />
                            );
                        })}
                    </Stack>
                </Box>
            </Box>
        </Collapse>
    );
};
